import React, { useEffect, useState } from "react";
import { Button, Row, Col, Container, Nav } from "reactstrap";
import { Modal } from "react-bootstrap";

const RechargeTransactionModal = (props) => {
const getMobNumber = () => {
  if(props.transactionDetail && props.transactionDetail.productType === "CALLINGCARDS") {
    return props.allUsersObject.phoneNumber;
  } else {
    return props.transactionDetail.mobileNumber;
  }
}
  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className="recharge-transaction-modal"
    >
      <Modal.Header closeButton>
        <Modal.Title>
          <h1>Transaction Details</h1>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div style={{ marginBottom: 15 }}>
          <Modal.Body>
            <Row className="modal-body-content" style={{ padding: "5px 0px" }}>
              <Col lg="5" className="label-bank-details">
                Type
              </Col>
              <Col lg="1">:</Col>
              <Col lg="6">
                {" "}
                {props.transactionDetail &&
                props.transactionDetail.rechargeType === "CALLINGCARDS"
                  ? "LOCAL"
                  : (props.transactionDetail &&
                      props.transactionDetail.rechargeType) ||
                    ""}
                {/* {(props.transactionDetail &&
                  props.transactionDetail.rechargeType) ||
                  ""} */}
              </Col>
            </Row>
            <Row className="modal-body-content" style={{ padding: "5px 0px" }}>
              <Col lg="5" className="label-bank-details">
                {" "}
                Product Type
              </Col>
              <Col lg="1">:</Col>
              <Col lg="6">
                {" "}
                {(props.transactionDetail &&
                  props.transactionDetail.productType) ||
                  ""}
              </Col>
            </Row>
            <Row className="modal-body-content" style={{ padding: "5px 0px" }}>
              <Col lg="5" className="label-bank-details">
                {" "}
                Sender Number
              </Col>
              <Col lg="1">:</Col>
              <Col lg="6">
                {/* {props.transactionDetail &&
                props.transactionDetail.productType === "CALLINGCARDS"
                  ? props.transactionDetail &&
                     props.transactionDetail.mobileNumber
                  : props.allUsersObject.phoneNumber */}
                {props.allUsersObject.phoneNumber}{" "}
                {/* {(props.transactionDetail &&
                  props.transactionDetail.senderNumber) ||
                  ""} */}
              </Col>
            </Row>
            <Row className="modal-body-content" style={{ padding: "5px 0px" }}>
              <Col lg="5" className="label-bank-details">
                {" "}
                Sent (
                {(props.transactionDetail &&
                  props.transactionDetail.sendAmount &&
                  props.transactionDetail.sendAmount.currency) ||
                  ""}
                )
              </Col>
              <Col lg="1">:</Col>
              <Col lg="6">
                {(props.transactionDetail &&
                  props.transactionDetail.sendAmount &&
                  props.transactionDetail.sendAmount.amount) ||
                  "0"}{" "}
                {(props.transactionDetail &&
                  props.transactionDetail.sendAmount &&
                  props.transactionDetail.sendAmount.currency) ||
                  ""}
              </Col>
            </Row>
            <Row className="modal-body-content" style={{ padding: "5px 0px" }}>
              <Col lg="5" className="label-bank-details">
                {" "}
                Fee (
                {(props.transactionDetail &&
                  props.transactionDetail.feeAmount &&
                  props.transactionDetail.feeAmount.currency) ||
                  ""}
                )
              </Col>
              <Col lg="1">:</Col>
              <Col lg="6">
                {" "}
                {(props.transactionDetail &&
                  props.transactionDetail.feeAmount &&
                  props.transactionDetail.feeAmount.amount) ||
                  "0"}{" "}
                {(props.transactionDetail &&
                  props.transactionDetail.feeAmount &&
                  props.transactionDetail.feeAmount.currency) ||
                  ""}
              </Col>
            </Row>
            <Row className="modal-body-content" style={{ padding: "5px 0px" }}>
              <Col lg="5" className="label-bank-details">
                {" "}
                Debited (
                {(props.transactionDetail &&
                  props.transactionDetail.feeAmount &&
                  props.transactionDetail.feeAmount.currency) ||
                  ""}
                )
              </Col>
              <Col lg="1">:</Col>
              <Col lg="6">
                {parseFloat(
                  props.transactionDetail &&
                    props.transactionDetail.sendAmount &&
                    props.transactionDetail.sendAmount.amount
                ) +
                  parseFloat(
                    props.transactionDetail &&
                      props.transactionDetail.feeAmount &&
                      props.transactionDetail.feeAmount.amount
                  )}
                {"  "}
                {(props.transactionDetail &&
                  props.transactionDetail.debitAmount &&
                  props.transactionDetail.debitAmount.currency) ||
                  ""}
              </Col>
            </Row>
            <Row className="modal-body-content" style={{ padding: "5px 0px" }}>
              <Col lg="5" className="label-bank-details">
                Receiver Number
              </Col>
              <Col lg="1">:</Col>
              <Col lg="6">
                {getMobNumber()}
                {/* {(props.transactionDetail &&
                  props.transactionDetail.mobileNumber) ||
                  ""}

                {props.transactionDetail &&
                props.transactionDetail.productType === "CALLINGCARDS"
                  ? props.allUsersObject.phoneNumber
                  : props.transactionDetail &&
                    props.transactionDetail.mobileNumber} */}
              </Col>
            </Row>
            <Row className="modal-body-content" style={{ padding: "5px 0px" }}>
              <Col lg="5" className="label-bank-details">
                Operator
              </Col>
              <Col lg="1">:</Col>
              <Col lg="6">
                {(props.transactionDetail &&
                  props.transactionDetail.operator) ||
                  ""}
              </Col>
            </Row>
            <Row className="modal-body-content" style={{ padding: "5px 0px" }}>
              <Col lg="5" className="label-bank-details">
                Receiving
              </Col>
              <Col lg="1">:</Col>
              <Col lg="6">
                {props.transactionDetail &&
                props.transactionDetail.receiveAmount &&
                props.transactionDetail.receiveAmount.amount === ""
                  ? 0
                  : (props.transactionDetail &&
                      props.transactionDetail.receiveAmount &&
                      props.transactionDetail.receiveAmount.amount) ||
                    ""}{" "}
                {(props.transactionDetail &&
                  props.transactionDetail.receiveAmount &&
                  props.transactionDetail.receiveAmount.currency) ||
                  ""}
              </Col>
            </Row>
            <Row className="modal-body-content" style={{ padding: "5px 0px" }}>
              <Col lg="5" className="label-bank-details">
                C3 Ref
              </Col>
              <Col lg="1">:</Col>
              <Col lg="6">
                {(props.transactionDetail && props.transactionDetail.c3Ref) ||
                  ""}
              </Col>
            </Row>
            <Row className="modal-body-content" style={{ padding: "5px 0px" }}>
              <Col lg="5" className="label-bank-details">
                Status
              </Col>
              <Col lg="1">:</Col>
              <Col lg="6">
                {" "}
                {(props.transactionDetail && props.transactionDetail.status) ||
                  ""}
              </Col>
            </Row>
          </Modal.Body>
        </div>
      </Modal.Body>
    </Modal>
  );
};
export default RechargeTransactionModal;
